module.exports = __webpack_public_path__ + "static/stalker-15b83eac6d0f62d90ab06124303d6112.jpg";